import styled from "styled-components";
import { Paragraph2, WrapperContainer } from "../../../../../components";
import { colors } from "../../../../../consts";
import { PagesWrapper } from "../../../../../components/PageSelector/styled";

export const FeaturesListTitle = styled(Paragraph2)`
  font-size: 14px;
  color: ${colors.RAISIN_70};
  line-height: 18px;
  margin-bottom: 12px;
`;

export const PageSelectorWrapper = styled(WrapperContainer)`
  ${PagesWrapper} {
    margin-top: 0;
  }
`;
